import { defineMessages } from "react-intl";

export const messages = defineMessages({
  exceedSize: {
    id: "admin.customerThemeSettings.exceedImageSize",
    defaultMessage: "Image size exceeds the limit of {maxSize}Kb",
    description: "Error message when file exceeds the limit",
  },
});
